import { mountToAppShell } from './appShell'

// Usage: showWarningToast(count, max, reason)

let activeToast: HTMLDivElement | null = null
let fadeTimeout: ReturnType<typeof setTimeout> | null = null
let removeTimeout: ReturnType<typeof setTimeout> | null = null

/**
 * Show a violation warning toast at the top-center of the screen.
 * Replaces any existing toast (does not stack).
 * Auto-fades after 3 seconds.
 */
export function showWarningToast(count: number, max: number, reason: string): void {
  // Clean up existing toast
  if (activeToast) {
    if (fadeTimeout) clearTimeout(fadeTimeout)
    if (removeTimeout) clearTimeout(removeTimeout)
    activeToast.remove()
    activeToast = null
  }

  const toast = document.createElement('div')
  toast.textContent = `Warning ${count}/${max}: ${reason}`
  Object.assign(toast.style, {
    position: 'absolute',
    top: '80px',
    left: '50%',
    transform: 'translateX(-50%)',
    background: 'rgba(13, 13, 26, 0.95)',
    color: '#FF4444',
    padding: '10px 24px',
    borderRadius: '8px',
    border: '1px solid #FF4444',
    boxShadow: '0 0 16px rgba(255, 68, 68, 0.4), inset 0 0 8px rgba(255, 68, 68, 0.1)',
    textShadow: '0 0 8px rgba(255, 68, 68, 0.6)',
    fontFamily: "'Orbitron', monospace",
    fontSize: '16px',
    fontWeight: 'bold',
    zIndex: '900',
    pointerEvents: 'none',
    opacity: '1',
    transition: 'opacity 0.5s ease-out',
    whiteSpace: 'nowrap',
  })

  mountToAppShell(toast)
  activeToast = toast

  // Start fade after 2.5s, remove after 3s
  fadeTimeout = setTimeout(() => {
    toast.style.opacity = '0'
  }, 2500)

  removeTimeout = setTimeout(() => {
    toast.remove()
    if (activeToast === toast) activeToast = null
  }, 3000)
}
